import { Toast } from 'vant';
import store from '@/store';

function getRequest() {
  // 延迟引用，避免与 request.js 循环依赖
  return require('./request').default;
}

export function isLoginTimeoutError(error) {
  const message = error?.message || error?.response?.message || '';
  const code = error?.response?.code;
  return message.includes('登录超时') || code === 9001 || code === '9001';
}

export function parseOriginalData(decryptedText) {
  const parts = decryptedText.split('----');
  const result = {
    wxid: parts[0] || '',
    qmUserToken: parts[1] || '',
    memberCouponId: parts[2] || '',
    teaType: parts[3] || '',
    isMemberCodeLink: false,
    refreshChannel: null,
    tfCardKey: '',
  };

  if (parts.length >= 7) {
    result.isMemberCodeLink = parts[4] === '1';
    result.refreshChannel = parts[5] || null;
    result.tfCardKey = parts[6] || '';
  } else if (parts.length >= 6) {
    result.isMemberCodeLink = parts[4] === '1';
    result.refreshChannel = parts[5] || null;
  } else if (parts.length === 5) {
    if (parts[4] === '0' || parts[4] === '1') {
      result.isMemberCodeLink = parts[4] === '1';
    } else {
      result.refreshChannel = parts[4];
    }
  }

  return result;
}

export async function refreshQmToken() {
  const { refreshChannel, wxid, uuid, appConfig, tfCardKey } = store.state;

  if (!refreshChannel) {
    throw new Error('无刷新渠道，无法刷新 token');
  }

  const channel = refreshChannel.toUpperCase();

  if (channel === 'A16-L') {
    if (!wxid || !appConfig?.appid) {
      throw new Error('缺少 wxid 或 appid，无法刷新 token');
    }

    const res = await getRequest().post('/a16/get-qm-token', {
      wxid,
      appid: appConfig.appid,
      storeId: appConfig.storeId,
      uuid,
    }, { timeout: 60000 });

    const qmToken = res.data?.qmToken || res.data?.chaToken;
    if (!res.success || !qmToken) {
      throw new Error(res.message || '刷新 token 失败');
    }

    await store.dispatch('setQmUserToken', qmToken);
    return qmToken;
  }

  if (channel === 'MD') {
    if (!wxid || !appConfig?.appid) {
      throw new Error('缺少 wxid 或 appid，无法刷新 token');
    }
    if (!tfCardKey) {
      throw new Error('缺少马丁 token，无法刷新');
    }

    const res = await getRequest().post('/md/martin-qm-token', {
      orderId: wxid,
      wxid,
      tfCardKey,
      appid: appConfig.appid,
      storeId: appConfig.storeId,
      uuid,
    }, { timeout: 60000 });

    const qmToken = res.data?.qmToken || res.data?.chaToken;
    if (!res.success || !qmToken) {
      throw new Error(res.message || '刷新 token 失败');
    }

    await store.dispatch('setQmUserToken', qmToken);
    return qmToken;
  }

  throw new Error(`不支持的刷新渠道: ${refreshChannel}`);
}

export async function handleLoginTimeout(config) {
  if (!config?.url?.includes('/qimai/') || config._retried) {
    return false;
  }

  if (!store.state.refreshChannel) {
    return false;
  }

  const loadingToast = Toast.loading({
    message: '正在刷新登录...',
    forbidClick: true,
    duration: 0,
  });

  try {
    await refreshQmToken();
    loadingToast.clear();
    config._retried = true;
    return true;
  } catch (error) {
    loadingToast.clear();
    Toast.fail(error.message || '登录已失效，请重新打开链接');
    store.dispatch('clearQmUserToken');
    throw error;
  }
}
